import React, { useContext } from 'react';
import './Sidebar.css';
import {
  DashboardOutlined,
  CalendarOutlined,
  NotificationOutlined,
  UserOutlined,
  DesktopOutlined,
  LockOutlined,
  SettingOutlined,
  ReadOutlined,
  BarChartOutlined,
  BankOutlined,
  DollarOutlined,
  SearchOutlined,
  StarOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  LineChartOutlined,
  AppstoreOutlined,
  MoneyCollectOutlined,
  UsergroupAddOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../Auth/AuthContext';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const { permissions } = useContext(AuthContext);
  const { role } = permissions;

  const { t } = useTranslation();

  const menuItems = [
    { iconName: "dashboard", tooltip: t('dashboard'), path: "/dashboard", roles: ["admin", "teacher", "student", "superadmin"] },
    { iconName: "myperformance", tooltip: t('myperformance'), path: "/myperformance", roles: ["student"] },
    { iconName: "annoucement", tooltip: t('announcement'), path: "/announcement", roles: ["admin", "teacher", "student", "superadmin"] },
    { iconName: "calendar", tooltip: t('calendar'), path: "/calendar", roles: ["admin", "teacher", "superadmin"] },
     { iconName: "mybilling", tooltip: t('billing'), path: "/studentbilling", roles: ["student"] },
    { iconName: "subject", tooltip: t('subject'), path: "/subject", roles: ["admin", "teacher", "student", "superadmin"] },
    { iconName: "teacher", tooltip: t('tutors'), path: "/teacher", roles: ["admin", "teacher", "student", "superadmin"] },
    { iconName: "classroom", tooltip: t('classrooms'), path: "/classroom", roles: ["admin", "superadmin"] },
    { iconName: "allclasses", tooltip: t('classes'), path: "/allclasses", roles: ["admin", "superadmin"] },
    { iconName: "quotation", tooltip: t('Quotation'), path: "/quotation", roles: ["admin", "superadmin"] },
    { iconName: "register", tooltip: t('register'), path: "/registrations", roles: ["admin", "superadmin"] },
    { iconName: "sales", tooltip: t('sales'), path: "/sales", roles: ["admin", "superadmin"] },
    { iconName: "adminpanel", tooltip: t('admin'), path: "/adminpanel", roles: ["admin", "superadmin"] },
    { iconName: "registrationlist", tooltip: t('attendance'), path: "/registrationlist", roles: ["admin", "superadmin"] },
    { iconName: "accounting", tooltip: t('accounting'), path: "/accounting", roles: ["superadmin"] },
    { iconName: "report", tooltip: t('report'), path: "/report", roles: ["superadmin"] },
    { iconName: "teacherhoursadmin", tooltip: t('tutor_hours'), path: "/teacher-hours-admin", roles: ["superadmin"] },
    { iconName: "teacherhours", tooltip: t('my_hours'), path: "/teacher-hours", roles: ["teacher"] },
    { iconName: "lessonplan", tooltip: t('Lesson Plan'), path: "/lessonplan", roles: ["teacher"] },
    { iconName: "salesperson", tooltip: t('Sales People'), path: "/sales-person", roles: ["superadmin"] },
    { iconName: "usercontrolpage", tooltip: t('users'), path: "/usercontrolpage", roles: ["superadmin"] },
  ];

  const iconMapping = {
    "dashboard": DashboardOutlined,
    "myperformance": StarOutlined,
    "annoucement": NotificationOutlined,
    "mybilling": FileTextOutlined,
    "subject": ReadOutlined,
    "calendar": CalendarOutlined,
    "teacher": UserOutlined,
    "classroom": DesktopOutlined,
    "allclasses": ReadOutlined,
    "quotation": MoneyCollectOutlined,
    "register": ShopOutlined,
    "sales": ShoppingCartOutlined,
    "adminpanel": SettingOutlined,
    "accounting": BankOutlined,
    "report": BarChartOutlined,
    "teacherhoursadmin": SearchOutlined,
    "teacherhours": DollarOutlined,
    "lessonplan": AppstoreOutlined,
    "registrationlist": LineChartOutlined,
    "salesperson": UsergroupAddOutlined,
    "usercontrolpage": LockOutlined,
  };

  const filteredMenuItems = menuItems.filter(item => item.roles.includes(role));

  return (
    <div className="modern-sidebar">
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {filteredMenuItems.map((item, index) => {
            const IconComponent = iconMapping[item.iconName];
            return (
              <li key={index} className="sidebar-item">
                <NavLink 
                  to={item.path} 
                  className={({isActive}) => 
                    isActive ? "sidebar-link active" : "sidebar-link"
                  }
                >
                  <div className="sidebar-icon-container">
                    <IconComponent className="sidebar-icon" />
                  </div>
                  <span className="sidebar-label">{item.tooltip}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;